import { FormattedMessage, useIntl } from "react-intl";
import {
  Button,
  DrawerBody,
  DrawerHeader,
  DrawerHeaderTitle,
  InlineDrawer,
} from "@fluentui/react-components";

import { Dismiss24Regular } from "@fluentui/react-icons";

import useMatchMedia from "@aglocal/web/hooks/useMatchMedia";

import PostMeetingAccordion, {
  type PostMeetingAccordionProps,
} from "./PostMeetingAccordion";
import { DIALOG_ACTIONS } from "./messages";

export interface PostMeetingDrawerProps extends PostMeetingAccordionProps {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
}

export default function PostMeetingDrawer({
  isOpen,
  onOpenChange,
  ...props
}: PostMeetingDrawerProps) {
  const { $t } = useIntl();
  const isXXL = useMatchMedia({ min: "xl" });
  return (
    <InlineDrawer
      as="aside"
      position="end"
      size={isXXL ? "medium" : "full"}
      open={isOpen}
    >
      <DrawerHeader>
        <DrawerHeaderTitle
          action={
            <Button
              appearance="subtle"
              aria-label={$t(DIALOG_ACTIONS.close)}
              icon={<Dismiss24Regular />}
              onClick={() => {
                onOpenChange(false);
              }}
            />
          }
        >
          <FormattedMessage
            defaultMessage="Details Gathered During Meeting"
            description="Title of the side drawer on the wrap-up page showing the Connected profile, skills and transcript."
          />
        </DrawerHeaderTitle>
      </DrawerHeader>

      <DrawerBody>
        <PostMeetingAccordion {...props} />
      </DrawerBody>
    </InlineDrawer>
  );
}
